import { NOTIFICATIONS__MUTATIONS } from "../mutation-types";
import { NOTIFICATIONS__ACTIONS } from "../action-types";
import { NOTIFICATIONS__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

const state = {
  notifications: [],
  lastNotificationCount: null,
  pollingInterval: null,
};

const mutations = {
  [NOTIFICATIONS__MUTATIONS.NOTIFICATIONS](state, data) {
    const currentCount = data.length;

    if (
      state.lastNotificationCount !== null &&
      currentCount > state.lastNotificationCount
    ) {
      const audio = document.getElementById("notification-bell");
      if (audio) {
        audio.currentTime = 0;
        audio.play();
      }
    }

    state.lastNotificationCount = currentCount;
    state.notifications = data;
  },
  [NOTIFICATIONS__MUTATIONS.SET_POLLING_INTERVAL](state, interval) {
    state.pollingInterval = interval;
  },
};

const getters = {};

const actions = {
  async [NOTIFICATIONS__ACTIONS.NOTIFICATIONS]({ commit }) {
    try {
      const response = await http().get(NOTIFICATIONS__API.NOTIFICATIONS);
      commit(NOTIFICATIONS__MUTATIONS.NOTIFICATIONS, response.data);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  async [NOTIFICATIONS__ACTIONS.UPDATE]({ dispatch }, id) {
    try {
      await http().post(`${NOTIFICATIONS__API.UPDATE}/${id}`);
      dispatch(NOTIFICATIONS__ACTIONS.NOTIFICATIONS);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  async [NOTIFICATIONS__ACTIONS.MARK_ALL_AS_READ]({ dispatch }) {
    try {
      await http().post(NOTIFICATIONS__API.MARK_ALL_AS_READ);
      dispatch(NOTIFICATIONS__ACTIONS.NOTIFICATIONS);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  async [NOTIFICATIONS__ACTIONS.SET_POLLING_INTERVAL]({ dispatch, commit }) {
    dispatch(NOTIFICATIONS__ACTIONS.NOTIFICATIONS);

    const interval = setInterval(() => {
      dispatch(NOTIFICATIONS__ACTIONS.NOTIFICATIONS);
    }, 5000);

    commit(NOTIFICATIONS__MUTATIONS.SET_POLLING_INTERVAL, interval);
  },
  async [NOTIFICATIONS__ACTIONS.STOP_POLLING_INTERVAL]({ state, commit }) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval);
      commit(NOTIFICATIONS__MUTATIONS.SET_POLLING_INTERVAL, null);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
